import { setWorksheetMassListSelected } from 'actions/worksheetMassActions';
import { createMassCheckboxCell } from 'components/common/tableComponents/cellTemplates';

export default createMassCheckboxCell('worksheetMass', setWorksheetMassListSelected);
